/**
 * @file index.tsx
 *
 * @fileoverview Component for displaying jobs of the week.
 */
import { Job, TopJobsParagraph } from '~/jobiqo/types/types';
import { JobTeasersGrid } from '~/jobiqo/components/Landingpage/JobsTeasersGrid';

interface TopJobsProps {
  /**
   * Top intro text for display on the landing page row.
   */
  topJobsInfo: TopJobsParagraph;
  /**
   * The size for the container.
   */
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}

export const TopJobs = ({ topJobsInfo, maxContainerSize }: TopJobsProps) => {
  if (topJobsInfo?.jobdata?.pages?.length === 0) {
    // Do not show the row if there are no jobs.
    return null;
  }

  return (
    <JobTeasersGrid
      jobs={(topJobsInfo?.jobdata?.pages as [Job]) ?? []}
      paragraphInfo={topJobsInfo}
      maxContainerSize={maxContainerSize}
    />
  );
};
export default TopJobs;
